import { render } from "./SubHeader.vue?vue&type=template&id=4405d168&scoped=true"
const script = {}

import "./SubHeader.vue?vue&type=style&index=0&id=4405d168&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4405d168"]])

export default __exports__